import React, { createRef, useEffect } from "react";
import lottie from "lottie-web";
//Assets
import { Container, LoadingElement } from "@components/Loading/styled";
const Loading = () => {
  const animationContainer = createRef<HTMLDivElement>();

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationContainer.current as Element,
      renderer: "svg",
      loop: true,
      autoplay: true,

      path: "https://bonnadona-public.s3.amazonaws.com/assets/loading.json",
    });
    return () => anim.destroy();
  }, [animationContainer]);
  return (
    <Container>
      <LoadingElement
        className="animation-container"
        ref={animationContainer}
      />
    </Container>
  );
};

export default Loading;
